/** 导出ffb层 (Front for backend) */
import type { AppFfbsConfig } from '@zto/zpage'

export const ffbs: AppFfbsConfig = {
  'base.getDataDicInfoList$': {
    afterResponse: (response: any) => {
      const resultData = response?.data?.result?.data
      if (!resultData?.length) return response

      const itemCodeKey = 'dataItemCode'
      const parentCodeKey = 'parentCode'

      // 将查询结果转换为树形结构
      const items: any[] = [...resultData]

      // 非顶级节点编号
      const childCodes: string[] = []

      for (let i = 0; i < items.length; i++) {
        for (let j = i; j < items.length; j++) {
          let pit, cit

          if (items[j][parentCodeKey] === items[i][itemCodeKey]) {
            pit = items[i]
            cit = items[j]
          } else if (items[i][parentCodeKey] === items[j][itemCodeKey]) {
            pit = items[j]
            cit = items[i]
          }

          if (pit && cit) {
            pit.children = pit.children || []
            pit.children.push(cit)
            childCodes.push(cit[itemCodeKey])
          }
        }
      }

      const topItems: any[] = items.filter(it => !childCodes.includes(it[itemCodeKey]))
      response.data.result.data = topItems

      return response
    }
  }
}
